import { routing } from '@/i18n/routing';

/**
 * Returns the localized path for internal links.
 * - Arabic (default): /path (no locale prefix, served at root)
 * - English: /en/path
 *
 * Use this for all internal links to ensure SEO-friendly URL structure.
 */
export function getLocalizedPath(locale: string, path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  const normalizedPath = cleanPath === '/' ? '' : cleanPath;

  if (locale === routing.defaultLocale) {
    return normalizedPath || '/';
  }

  return `/en${normalizedPath}`;
}
